import { Moon, Sun } from "lucide-react";
import { useTheme } from "@hub/shared/hooks/useTheme";

export function ThemeToggle() {
  const { resolvedTheme, toggleTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-coronis-navy-800 transition-colors"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
        <Sun className="h-5 w-5 text-coronis-blue-400" />
      ) : (
        <Moon className="h-5 w-5 text-coronis-navy-600" />
      )}
    </button>
  );
}
